<script setup>
import ApplicationLogo from '@/Components/ApplicationLogo.vue';
</script>

<template>
  <div
    class="min-h-screen flex flex-col sm:justify-center items-center pt-6 px-2 sm:pt-0 bg-gray-100"
  >
    <div class="flex min-h-full flex-col justify-center py-6 sm:px-6 lg:px-8">
      <a href="/">
        <ApplicationLogo class="w-20 h-20 fill-current text-gray-500" />
      </a>
    </div>

    <div
      class="w-full sm:max-w-md mt-6 px-6 py-4 bg-white dark:bg-gray-800 shadow-md overflow-hidden sm:rounded-lg"
    >

      <slot />
    </div>
  </div>
</template>
